import React from 'react'
import { Checkbox, CheckboxProps, FormControlLabel } from '@mui/material'
import { useFormContext, UseFormReturn } from 'react-hook-form'

type CheckBoxProps = {
    name: string
    label: string
    formMethods: UseFormReturn
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
} & CheckboxProps

const CheckBox = ({ name, label, formMethods, ...props }: CheckBoxProps) => {
    const { onChange, ...restOfProps } = props

    // Subscribe to the form value using watch
    const isChecked = formMethods.watch(name)

    const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const checked = event.target.checked
        formMethods.setValue(name, checked) // Update form state
        if (onChange) onChange(event) // Call custom onChange if provided
    }

    return (
        <FormControlLabel
            control={<Checkbox {...restOfProps} checked={!!isChecked} onChange={handleOnChange} />}
            label={label}
        />
    )
}

const RegisteredCheckBox = ({
    name,
    label,
    ...props
}: { name: string; label: string } & Omit<CheckBoxProps, 'formMethods'>) => {
    const formMethods = useFormContext()
    return <CheckBox name={name} label={label} formMethods={formMethods} {...props} />
}

export { CheckBox, RegisteredCheckBox }
